var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.37 0.580003C14.866 0.411985 15.4062 0.429898 15.89 0.630407C16.3738 0.830916 16.7682 1.20037 17 1.67L20.42 8.6L28.2899 9.88C28.6875 9.93541 29.0614 10.1015 29.369 10.3593C29.6766 10.617 29.9056 10.9561 30.0297 11.3378C30.1538 11.7195 30.168 12.1284 30.0708 12.5178C29.9736 12.9072 29.7689 13.2614 29.48 13.54L23.95 18.93L25.17 26.82C25.2458 27.2226 25.205 27.6384 25.0525 28.0186C24.8999 28.3987 24.6419 28.7274 24.3089 28.9659C23.9758 29.2044 23.5816 29.3428 23.1725 29.3647C22.7635 29.3867 22.3567 29.2914 22 29.09L15.1599 25.49L8.03995 29.09C7.53362 29.3515 6.94536 29.4053 6.4 29.24C5.91765 29.068 5.51208 28.7303 5.25565 28.2871C4.99922 27.8438 4.9086 27.3239 4.99997 26.82L6.30997 19.21L0.689975 13.54C0.40106 13.2614 0.196295 12.9072 0.0990934 12.5178C0.00189152 12.1284 0.016193 11.7195 0.140292 11.3378C0.264391 10.9561 0.493312 10.617 0.800937 10.3593C1.10856 10.1015 1.48247 9.93541 1.87998 9.88L9.51999 8.77L13.17 1.67C13.4253 1.15882 13.8702 0.767659 14.4099 0.580003H14.37Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.8a7ea03474e4cc18668067ae1a7c8a9d.svg";
export { ForwardRef as ReactComponent };